import masks from "@/app/utils/masks";

type RowProps = {
  label: string;
  value: string;
};

const Row = ({ label, value }: RowProps) => (
  <div className="flex items-center justify-between text-sm">
    <span className="text-gray-500">{label}</span>
    <span>{value}</span>
  </div>
);

type OfferDetailsProps = {
  condicao: {
    valor_solicitado: number;
    valor_parcela: number;
    valor_liquido: number;
    valor_bruto: number;
    valor_iof: number;
    data_primeiro_vencimento: string;
    data_ultimo_vencimento: string;
    custo_total_efetivo_mensal: number;
    custo_total_efetivo_anual: number;
    taxa_cliente_mensal: number;
    taxa_cliente_anual: number;
  };
  commission: number;
};

export default function OfferDetails({
  condicao,
  commission,
}: OfferDetailsProps) {
  const formatDate = (dateString: string): string => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");

    return `${day}/${month}/${year}`;
  };

  return (
    <div className="space-y-2">
      <div className="my-4 border-t border-gray-100" />

      <div>
        <p className="font-semibold">Resumo da simulação</p>
        <Row
          label="Comissão"
          value={`${masks.currency(
            String(Math.round(condicao.valor_liquido * commission)),
          )} (${commission}%)`}
        />
        <Row
          label="Valor solicitado"
          value={masks.currency(String(Math.round(condicao.valor_solicitado * 100)))}
        />
        <Row
          label="Valor líquido"
          value={masks.currency(String(Math.round(condicao.valor_liquido * 100)))}
        />
        <Row
          label="Valor bruto"
          value={masks.currency(String(Math.round(condicao.valor_bruto * 100)))}
        />
        <Row
          label="Valor da parcela"
          value={masks.currency(String(Math.round(condicao.valor_parcela * 100)))}
        />
        <Row
          label="IOF"
          value={masks.currency(String(Math.round(condicao.valor_iof * 100)))}
        />
      </div>

      <div className="my-4 border-t border-gray-100" />

      <div>
        <p className="font-semibold">Vencimentos</p>
        <Row
          label="Primeira parcela"
          value={formatDate(condicao.data_primeiro_vencimento)}
        />
        <Row
          label="Última parcela"
          value={formatDate(condicao.data_ultimo_vencimento)}
        />
      </div>

      <div className="my-4 border-t border-gray-100" />

      <div>
        <p className="font-semibold">Taxas</p>
        <Row
          label="CET mensal"
          value={`${condicao.custo_total_efetivo_mensal}%`}
        />
        <Row
          label="CET anual"
          value={`${condicao.custo_total_efetivo_anual}%`}
        />
        <Row label="Taxa mensal" value={`${condicao.taxa_cliente_mensal}%`} />
        <Row label="Taxa anual" value={`${condicao.taxa_cliente_anual}%`} />
      </div>
    </div>
  );
}
